import * as validators from 'utils/validators';

export const required = validators.required();
export const requiredRadioButton = validators.required();
export const notEmpty = validators.notEmpty();
export const isAddress = validators.isAddress();
export const isNumber = validators.isNumber();
export const isURL = validators.isURL();
export const isEmail = validators.isEmail();
export const isPhone = validators.isPhone();
export const maxLength1 = validators.maxLength(1);
export const maxLength3 = validators.maxLength(3);
export const maxLength5 = validators.maxLength(5);
export const maxLength10 = validators.maxLength(10);
export const maxLength5000 = validators.maxLengthRichText(5000);
